import React from 'react';
import { func_datetime, func_validation, isStringTrimNotEmpty } from 'functions';
import { Tooltip } from 'components/informational/Tooltip';

export function useTableColumns() {

    function getColumn_module() {
        let columnClassName = "columns__module";

        return {
            headerCellClassName: columnClassName + " ",
            Header: "Module",
            id: "module",
            accessor: "Module",
            bodyCellClassName: columnClassName + " ",
            Cell: (props) => {
                let value = props?.cell?.value;
                let value_formatted = func_validation.isStringTrimNotEmpty(value)? value: "-";
    
                return (
                    <div className={"noWrap-text-ellipsis"}>{value_formatted}</div>
                );
            },
        }
    }

    function getColumn_referenceKey() {
        let columnClassName = "columns__referenceKey";

        return {
            headerCellClassName: columnClassName + " ",
            Header: "Reference Key",
            id: "referenceKey",
            accessor: "ReferenceKey",
            bodyCellClassName: columnClassName + " ",
            Cell: (props) => {
                let value = props?.cell?.value;
                let value_formatted = func_validation.isStringTrimNotEmpty(value)? value: "-";
    
                return (
                    <div className={"noWrap-text-ellipsis"}>{value_formatted}</div>
                );
            },
        }
    }

    function getColumn_username() {
        let columnClassName = "columns__username";

        return {
            headerCellClassName: columnClassName + " ",
            Header: "Username",
            id: "username",
            accessor: "UserName",
            bodyCellClassName: columnClassName + " ",
            Cell: (props) => {
                let value = props?.cell?.value;
                let value_formatted = func_validation.isStringTrimNotEmpty(value)? value: "-";
    
                return (
                    <div className={"noWrap-text-ellipsis"}>{value_formatted}</div>
                );
            },
            width: 300
        }
    }

    function getColumn_date() {
        let columnClassName = "columns__date";

        return {
            headerCellClassName: columnClassName + " ",
            Header: "Date",
            id: "date",
            accessor: "Date",
            bodyCellClassName: columnClassName + " ",
            Cell: (props) => {
                let value = props?.cell?.value;
                let value_formatted = func_validation.isStringTrimNotEmpty(value)? value: "-";
                if (func_validation.isStringTrimNotEmpty(value_formatted) && (value_formatted != "-")) 
                    value_formatted = func_datetime.convertDateTimeToLocal(value_formatted, "DD/MM/YYYY");
    
                return (
                    <div className={"noWrap-text-ellipsis"}>{value_formatted}</div>
                );
            },
        }
    }

    function getColumn_msg() {
        let columnClassName = "columns__msg flex-fill ";

        return {
            headerCellClassName: columnClassName + " ",
            Header: "Message",
            id: "msg",
            accessor: "MessageDetail",
            bodyCellClassName: columnClassName + " ",
            Cell: (props) => {
                let value = props?.cell?.value;
                let message = props?.row?.original?.Message;
                let value_formatted = func_validation.isStringTrimNotEmpty(value)? value: 
                        (isStringTrimNotEmpty(message)? message:"-");
    
                return (
                    <Tooltip
                        className={"w-100"}
                        targetContentClassName={"msg__content noWrap-text-ellipsis"}
                        target={value_formatted}
                        tooltipContent={value_formatted}
                        isCopyTargetTextRequired={value_formatted !== "-"}
                    />
                );
            },
            width: 300
        }
    }

    return [
        getColumn_username(),
        getColumn_date(),
        getColumn_module(),
        getColumn_referenceKey(),
        getColumn_msg(),
    ]
}